import { Link } from 'react-router-dom';

export function DPAPage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Data Processing Agreement (DPA)
                    </h2>
                    <p className="fs-8">
                      This Data Processing Agreement (&quot;DPA&quot;)
                      supplements and forms part of the Terms of Service between
                      Yapamar OÜ (&quot;Processor&quot;) and the customer
                      (&quot;Controller&quot;). In the event of a conflict, the
                      provisions of this DPA shall prevail with respect to
                      personal data processing. This DPA is entered into in
                      accordance with Article 28 of Regulation (EU) 2016/679
                      (General Data Protection Regulation, &quot;GDPR&quot;).
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>1. Parties</h5>
                    <p>
                      <strong>Data Controller:</strong> Customer
                      <br />
                      <strong>Data Processor:</strong> Yapamar OÜ
                    </p>

                    <h5>2. Background and Purpose</h5>
                    <p>
                      The parties have entered into an agreement under which the
                      Data Controller (<strong>Controller</strong>) has
                      commissioned the Data Processor (
                      <strong>Processor</strong>) to process personal data on
                      behalf of the Controller (<strong>Main Agreement</strong>
                      ).
                    </p>
                    <p>
                      These terms together with Annexes and the Main Agreement
                      constitute the written agreement for the processing of
                      such personal data as required by Article 28 of the EU
                      General Data Protection Regulation (2016/679;{' '}
                      <strong>GDPR</strong>).
                    </p>
                    <p>
                      The subject matter, duration, nature, purpose, types of
                      data categories to be processed, and the categories of
                      data subjects whose information concerns are further
                      specified in the Main Agreement and in the Annex of these
                      terms. Unless otherwise agreed, each party shall bear its
                      own costs related to the performance of its obligations
                      under these terms.
                    </p>

                    <h5>3. General Responsibilities of Data Processor</h5>
                    <p>
                      Processor shall ensure that the processing of personal
                      data is performed in accordance with the GDPR and other
                      mandatory legislation, and as reasonably instructed by
                      Controller in the Main Agreement or otherwise in writing.
                    </p>
                    <p>
                      If Processor is under an obligation to disclose or divulge
                      personal data to a third party, Processor shall aim to
                      notify Controller in advance, unless otherwise required by
                      law.
                    </p>
                    <p>
                      Processor shall reasonably assist Controller in exercising
                      the data subject&apos;s rights under the GDPR in relation
                      to Controller by providing information necessary to
                      respond to an access request.
                    </p>
                    <p>
                      Processor may charge for the same in accordance with its
                      price list.
                    </p>
                    <p>
                      Processor shall, at the request of Controller, provide
                      Controller with information reasonably necessary to ensure
                      that Processor has complied with these terms, the Main
                      Agreement, and the law applicable to the processing
                      measures. In the situations required by the GDPR,
                      Processor shall also allow Controller, or an auditor
                      appointed by Controller, to execute an audit or inspection
                      that is reasonably necessary to ensure the above and/or
                      assist to a reasonable extent in conducting a data
                      protection impact assessment. Processor may charge for
                      such measures in accordance with its price list. Processor
                      shall aim to inform Controller if it considers that the
                      instructions it has received are in breach of applicable
                      law.
                    </p>

                    <h5>4. Subprocessors and Transfer Outside EU/EEA</h5>
                    <p>
                      Processor will not transfer data outside the EU/EEA
                      without Controller&apos;s written permission.
                    </p>
                    <p>
                      Where Processor transfers personal data outside the EU/EEA
                      in accordance with the above, Processor shall, upon
                      request, provide Controller with a list of all processing
                      locations outside the EU/EEA.
                    </p>
                    <p>
                      If Processor transfers personal data outside the EU/EEA as
                      described above, Processor must ensure that the data
                      outside the EU/EEA is protected by a transfer mechanism in
                      accordance with the GDPR, such as the model contractual
                      clauses adopted by the European Commission. The applicable
                      transfer mechanism shall be indicated in the list of
                      processors referred to below.
                    </p>
                    <p>
                      Controller provides general authorisation for Processor to
                      engage sub-processors, subject to the conditions in this
                      clause.
                    </p>
                    <p>
                      A list of current sub-processors is set out in Annex 1.
                    </p>
                    <p>
                      Processor shall give at least 30 days&apos; prior written
                      notice of any intended addition or replacement of
                      sub-processors, thereby giving Controller the opportunity
                      to object to such changes for legitimate reasons.
                    </p>
                    <p>
                      If Controller objects to a new sub-processor, Controller
                      shall terminate the Main Agreement by providing written
                      notice, with termination effective before the new
                      sub-processor is engaged. No fees shall be refundable if
                      Customer terminates pursuant to this clause.
                    </p>
                    <p>
                      When using subprocessors, Processor shall enter into
                      written agreements ensuring such subprocessors comply with
                      data protection obligations materially equivalent to those
                      binding Processor hereunder.
                    </p>

                    <h5>5. Data Protection and Data Breaches</h5>
                    <p>
                      The personal data shall be considered confidential
                      information of Controller, which Processor is obliged to
                      keep confidential, unless otherwise provided for in the
                      subject matter or the purpose of the contract.
                    </p>
                    <p>
                      Processor declares that its employees and other
                      representatives involved in the processing measures
                      referred herein have either signed a non-disclosure
                      agreement or are directly bound by law to observe
                      professional secrecy.
                    </p>
                    <p>
                      Processor shall ensure that the processing and storage of
                      personal data is conducted in accordance with technical
                      and organisational security measures that are appropriate
                      and adequate considering the nature of the processing and
                      the data. Upon assessing the adequate level of security,
                      Processor shall take into account the state of the art,
                      the costs, the scope and nature of the personal data
                      processed, the risks associated with the processing
                      measures, and similar factors. At the request of
                      Controller, Processor shall provide Controller with a
                      reasonable written explanation of its security measures
                      and the adequacy of those measures, taking into account
                      the established practices in the sector. If Processor
                      considers that it does not have sufficient expertise to
                      assess the adequate level of data protection in
                      Processor&apos;s industry, it shall inform Controller. The
                      applicable data security requirements may also be further
                      specified in the Main Agreement, an Annex to these terms
                      or any other binding document between the parties.
                    </p>
                    <p>
                      If Processor has a reason to suspect that its premises or
                      information systems have been breached or that personal
                      data have otherwise been disclosed to a third party (other
                      than as part of transfers permitted under the Main
                      Agreement or these terms) or have been lost/altered, it
                      must notify Controller. Processor shall assist Controller
                      with necessary measures to comply with obligations
                      applicable to the situation, including the drafting of
                      notifications to Controller and the authorities, and
                      otherwise cooperate with Controller.
                    </p>

                    <h5>6. Termination of Agreement</h5>
                    <p>
                      These terms are in force during the term of the Main
                      Agreement.
                    </p>
                    <p>
                      Upon the termination of the Main Agreement, Processor
                      shall terminate the processing of personal data and return
                      to Controller the data held by Processor that it is
                      responsible for and destroy any remaining copies of the
                      data unless otherwise provided by law.
                    </p>
                    <p>
                      Other termination procedures may also be agreed upon a
                      case-by-case basis. If the parties have agreed upon an
                      obligation to preserve data or an obligation to assist in
                      the termination or similar, Processor may only destroy the
                      data after having successfully complied with all such
                      requirements.
                    </p>

                    <h5>
                      Description of the personal data subject to processing and
                      the data subjects
                    </h5>
                    <div className="card card-bordered p-5 mb-5">
                      <p>
                        <strong>Purpose of processing:</strong>
                        <br />
                        Processor processes personal data as part of providing
                        cloud-based marketing intelligence software-as-a-service
                        together with related offerings to Controller as set out
                        in more detail in the Main Agreement.
                      </p>
                      <p>
                        <strong>Personal data types:</strong> Within the scope
                        of the services, Processor may process the following
                        personal data types:
                      </p>
                      <ul>
                        <li>Name</li>
                        <li>Job title</li>
                        <li>Address</li>
                        <li>Email</li>
                        <li>Phone number</li>
                        <li>Customer account data</li>
                        <li>Usage logs</li>
                        <li>
                          Any marketing or media data provided by Controller
                          through the service
                        </li>
                      </ul>
                      <p>
                        <strong>Data subject categories:</strong> Within the
                        scope of the services, personal data of the following
                        data subject categories may be processed:
                      </p>
                      <ul>
                        <li>Customer&apos;s employees and personnel</li>
                        <li>Customer&apos;s business contacts and leads</li>
                        <li>
                          Recipients of Customer&apos;s marketing campaigns and
                          communications
                        </li>
                        <li>
                          Other individuals whose personal data is processed by
                          Processor on behalf of Customer for marketing
                          intelligence, planning, and decision-making purposes
                        </li>
                      </ul>
                      <p>
                        No special categories of personal data are intended to
                        be processed.
                      </p>
                      <p className="mb-0">
                        <strong>Duration of processing:</strong> For the
                        duration of the Main Agreement.
                      </p>
                    </div>

                    <h5>Sub-processors</h5>
                    <div className="card card-bordered p-5 mb-5">
                      <p>
                        <strong>Name:</strong> AWS
                        <br />
                        <strong>Description of processing:</strong> Service
                        infrastructure provider
                        <br />
                        <strong>Location of processing:</strong> EU/ETA
                        <br />
                        <strong>
                          Transfer mechanism if outside EU/ETA:
                        </strong>{' '}
                        N/A
                      </p>
                      <p>
                        <strong>Name:</strong> Amplitude
                        <br />
                        <strong>Description of processing:</strong> Registers
                        statistical data on users&apos; behaviour on the website
                        and captures acquisition-source information (referring
                        URL, referring domain, UTM parameters, click identifiers
                        such as gclid and fbclid). Used for internal analytics
                        by the website operator.
                        <br />
                        <strong>Location of processing:</strong> EU/ETA
                        <br />
                        <strong>
                          Transfer mechanism if outside EU/ETA:
                        </strong>{' '}
                        N/A
                      </p>
                      <p>
                        <strong>Name:</strong> Sentry
                        <br />
                        <strong>Description of processing:</strong> Registers
                        data on visitors&apos; website behaviour. This is used
                        for internal analysis and website optimization.
                        <br />
                        <strong>Location of processing:</strong> EU/ETA
                        <br />
                        <strong>
                          Transfer mechanism if outside EU/ETA:
                        </strong>{' '}
                        N/A
                      </p>
                      <p className="mb-0">
                        The list of sub-processors is available at{' '}
                        <Link to="/subprocessors">/subprocessors</Link>.
                      </p>
                    </div>

                    <h5>Contact</h5>
                    <p>
                      For any questions regarding this Data Processing
                      Agreement:
                    </p>
                    <p className="d-flex align-items-center gap-2 mb-1">
                      <em className="icon ni ni-mail" />
                      <a href="mailto:support@yapamar.com">
                        support@yapamar.com
                      </a>
                    </p>
                    <p className="d-flex align-items-center gap-2">
                      <em className="icon ni ni-map-pin" />
                      Sepapaja 6, Tallinn 15551, Estonia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
